<div class="card-news-details-wrapper">
  <div class="card-news-details">
    <!-- news header -->
    <div class="card-news-details__header">
      <tpm-button button-link data-cy="back-to-news-button" icon="gpi-chevron-left" (click)="onClose()">
        {{ "CONTENTFUL.BACK_TO_NEWS_PAGE" | translate }}
      </tpm-button>
    </div>
    <!-- news body -->
    <div *ngIf="!!selectedEntry" class="card-news-details__body">
      <img class="full-size-media" *ngIf="!selectedEntry.video" [src]="selectedEntry.teaserImage" />
      <video-player
        class="full-size-media"
        *ngIf="selectedEntry.video"
        [source]="$any(selectedEntry.video.fields.file.url)"
        [title]="$any(selectedEntry.video.fields.title)"
      ></video-player>
      <div class="card-news-details__body__textual-content">
        <div class="elements">
          <div class="date body-xs">{{ selectedEntry.date | date : "dd.MM.yyyy" }}</div>
          <tpm-colored-badge
            *ngIf="selectedEntry.isNew"
            class="new-badge"
            text="Neu"
            [backgroundColor]="'--kp-color-blue-50'"
            [color]="'--kp-color-blue-700'"
          ></tpm-colored-badge>
          <tpm-icon *ngIf="selectedEntry.checkCritical" class="critical-badge" icon="ec_warning"></tpm-icon>
        </div>
        <div class="headline" [ngClass]="(isMobileView$ | async) === false ? 'h3' : 'h5'">
          {{ selectedEntry.headline }}
        </div>
        <div class="teaser body-sm">{{ selectedEntry.teaser }}</div>
        <div class="text-article body-sm" [innerHTML]="selectedEntry.textArticle"></div>
        <div *ngIf="selectedEntry.actions" class="card-news-details__body__actions">
          <tpm-button
            *ngFor="let action of selectedEntry.actions; trackBy: trackByLabel"
            button-link
            iconRight="gpi-external-link"
            (click)="onActionClick($any(action))"
          >
            {{ action.label }}
          </tpm-button>
        </div>
      </div>
    </div>
  </div>
</div>
